import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.cloudAccounts || initialState;

export const selectCloudAccounts = createSelector(
  [selectDomain],
  cloudAccountsState => cloudAccountsState,
);
